import styled from 'styled-components';
import { colors } from 'shared-library';

export const HPPBookingContainer = styled.div`
  padding-top: 30px;
  border-top: 1px solid ${({ theme }) => theme.sectionBorderColor || colors.primary};
`;
